import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import video from "../../../assets/img/successAnimation.mp4";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import {
  stripePrice,
  stripeProductsData,
  stripeSubscriptionUpdate,
} from "../../../Redux/Stripe/action";

const ChangePlanModal = ({ subscriptionDetails, isOpen, closeModal }) => {
  const dispatch = useDispatch();
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [confirmationText, setConfirmationText] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [subscriptionError, setSubscriptionError] = useState(null);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [plans, setPlans] = useState([]);
  const [billingCycle, setBillingCycle] = useState("always_invoice");
  const [Packages, setPackages] = useState(null);
  const allProductsSuccess = useSelector(
    (state) => state.stripeReducer.allProductsSuccess,
  );
  const subscriptionUpdateSuccess = useSelector(
    (state) => state.stripeReducer.subscriptionUpdateSuccess,
  );
  const handleChangeTiming = (timing) => {
    setBillingCycle(timing);
  };

  useEffect(() => {
    const fetchData = async () => {
      await stripeProductsData(dispatch, 100, true);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (allProductsSuccess) {
      setPackages(allProductsSuccess);
    }
  }, [allProductsSuccess]);

  useEffect(() => {
    const fetchData = async () => {
      if (Packages) {
        const fetchedPlans = [];

        for (const item of Packages.data) {
          let price = null;

          if (item.default_price !== null) {
            try {
              price = await stripePrice(dispatch, item?.default_price);
            } catch (error) {
              console.error("Error fetching price:", error);
            }
          }
          fetchedPlans.push({
            minutes: item?.metadata?.quota,
            additionalCost: "", // You can fill this in with any additional cost logic if needed
            totalCost: price?.unit_amount / 100 || "", // Convert the price from cents to dollars
            priceID: item?.default_price,
          });
        }
        setPlans(fetchedPlans);
      }
    };

    fetchData();
  }, [Packages]);

  const userPreviousPackage = subscriptionDetails?.plan?.id;
  const handlePlanClick = (plan) => {
    if (selectedPlan && selectedPlan.priceID === plan.priceID) {
    } else if (plan.priceID !== userPreviousPackage) {
      setSelectedPlan(plan);
    }
  };

  useEffect(() => {}, [selectedPlan]);
  const handleChangePlan = () => {
    setShowConfirmationModal(true);
  };

  const handleConfirmation = async () => {
    try {
      if (confirmationText.toLowerCase() === "confirm") {
        // Update subscription
        await stripeSubscriptionUpdate(
          dispatch,
          subscriptionDetails?.id,
          subscriptionDetails?.items?.data[0]?.id,
          selectedPlan?.priceID,
          billingCycle,
        );
        if (subscriptionUpdateSuccess) {
          setConfirmationText("");
          setSelectedPlan(null);
          setShowConfirmationModal(false);
          setShowSuccessAnimation(true);
        }
      }
    } catch (error) {
      setSubscriptionError("Error updating subscription. Please try again. ");
    }
  };
  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
    setSubscriptionError(null);
    setConfirmationText("");
  };
  const isConfirmationTextValid = confirmationText === "Confirm";
  const showProceedButton = confirmationText && isConfirmationTextValid;

  plans.sort((a, b) =>
    a.priceID === userPreviousPackage
      ? -1
      : b.priceID === userPreviousPackage
        ? 1
        : 0,
  );

  const handleCloseSuccessModal = () => {
    setShowSuccessAnimation(false);
    window.location.reload();
  };
  return (
    <>
      {/* Success Animation Modal */}
      <Modal
        centered
        backdrop="static"
        show={showSuccessAnimation}
        onHide={handleCloseSuccessModal}
      >
        <Modal.Body className="success-animation-modal">
          <video
            src={video}
            centered
            width="600"
            height="300"
            autoPlay={true}
            onEnded={handleCloseSuccessModal}
            muted={true}
          />
        </Modal.Body>
      </Modal>

      <Modal
        size="xl"
        show={isOpen}
        onHide={() => {
          closeModal();
          setSelectedPlan(null);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className={"main-h4-tag-large"}>
            Upgrade Your Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              {plans.map((plan, index) => (
                <Col key={index} md={3} style={{ marginBottom: "20px" }}>
                  <Card
                    style={{
                      backgroundColor:
                        plan.priceID === userPreviousPackage
                          ? "green"
                          : selectedPlan?.priceID === plan.priceID
                            ? "#172e57"
                            : "#e8e8e8",
                      color:
                        plan.priceID === userPreviousPackage ||
                        selectedPlan?.priceID === plan.priceID
                          ? "white"
                          : "#172e57",
                      borderRadius: "10px",
                      height: "100%",
                      border:
                        plan.priceID === selectedPlan?.priceID
                          ? "2px solid #172e57"
                          : "none",
                      cursor:
                        plan.priceID !== userPreviousPackage
                          ? "pointer"
                          : "default",
                    }}
                    onClick={() => handlePlanClick(plan)}
                  >
                    <Card.Body>
                      <Card.Title
                        className={"d-flex justify-content-center"}
                        style={{
                          fontSize: "20px",
                          fontWeight: "bolder",
                        }}
                      >
                        {plan.minutes} Minutes
                      </Card.Title>
                      <Card.Text
                        className={"d-flex justify-content-center"}
                        style={{ fontSize: "14px" }}
                      >
                        ${plan.additionalCost} per additional minute
                      </Card.Text>
                      <Card.Text
                        className={"d-flex justify-content-center mt-3"}
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                        }}
                      >
                        ${plan.totalCost}.00
                      </Card.Text>
                      {plan.priceID === userPreviousPackage && (
                        <div
                          className="d-flex justify-content-center mt-3"
                          style={{ fontWeight: "bold" }}
                        >
                          Current Package
                        </div>
                      )}
                      {plan.priceID === selectedPlan?.priceID && (
                        <div className={"d-flex justify-content-center"}>
                          <style>
                            {`
                              .custom-button-plan-primary {
                                background-color: white !important;
                                border-color: #172e57 !important;
                                color: #172e57 !important;
                              }

                              .custom-button-plan-primary:hover {
                                background-color: #9b9b9b !important;
                                border-color: #172e57 !important;
                                color: white !important;
                              }
                            `}
                          </style>
                          <Button
                            // variant="primary"
                            className="mt-3 d-flex justify-content-center custom-button-plan-primary"
                            onClick={handleChangePlan}
                          >
                            Change Plan
                          </Button>
                        </div>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        centered
        backdrop="static"
        show={showConfirmationModal}
        onHide={handleCloseConfirmationModal}
      >
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#172e57", color: "white" }}
        >
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
          <Form.Group controlId="changeTiming">
            <Form.Label style={{ fontWeight: "bold", color: "#172e57" }}>
              Select Change Timing
            </Form.Label>
            <div className={"d-flex justify-content-between ml-4 mr-4"}>
              <Form.Check
                type="radio"
                label="Effective Immediately"
                name="changeTiming"
                id="immediately"
                checked={billingCycle === "always_invoice"}
                onChange={() => handleChangeTiming("always_invoice")}
              />
              <Form.Check
                type="radio"
                label="Next Billing Cycle"
                name="changeTiming"
                id="nextBillingCycle"
                checked={billingCycle === "none"}
                onChange={() => handleChangeTiming("none")}
              />
            </div>
          </Form.Group>
          <Form.Group controlId="confirmationText">
            <Form.Label style={{ fontWeight: "bold", color: "#172e57" }}>
              Please type "Confirm" to proceed
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Type here"
              value={confirmationText}
              onChange={(e) => setConfirmationText(e.target.value)}
              style={{ border: "1px solid #ced4da" }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#f8f9fa" }}>
          {subscriptionError && (
            <div
              style={{ color: "red", fontSize: "small", margin: "auto" }}
              className={"w-50 p-0"}
            >
              {subscriptionError}
            </div>
          )}
          <div>
            <Button
              variant="secondary"
              onClick={handleCloseConfirmationModal}
              style={{ backgroundColor: "#6c757d", borderColor: "#6c757d" }}
            >
              Close
            </Button>
            {showProceedButton && (
              <Button
                variant="primary"
                onClick={handleConfirmation}
                style={{ backgroundColor: "#172e57", borderColor: "#172e57" }}
              >
                Proceed
              </Button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChangePlanModal;
